import Vue from 'vue';

export const recentItemsService = {
  async retrieveRecentItems(userId, limit, offset = null, sortOrder = null) {
    return Vue.axios
      .get(`/event-log/views/${userId}`, {
        params: {
          ...sortOrder,
          limit,
          offset
        }
      })
      .then(response => response.data);
  },

  async retrieveFilteredRecordCount(userId) {
    return Vue.axios.get(`/event-log/views/${userId}/count`).then(response => response.data);
  },
  async deleteRecentItems(params) {
    return Vue.axios
      .delete(`event-log/delete`, {
        data: {
          ...params
        }
      })
      .then(response => response.data);
  }
};
